<template>
  <v-dialog
    :value="value"
    max-width="500px"
    @input="$emit('input', $event)"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">Invite User</span>
      </v-card-title>

      <v-card-text>
        <v-container>
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="emailAddress"
                label="Email Address"
                :rules="emailRules"
                type="email"
                required
                outlined
                dense
              />
            </v-col>
            <v-col cols="12">
              <v-text-field
                v-model="name"
                label="Name (optional)"
                outlined
                dense
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-alert
                v-if="isDeakinEmail"
                type="info"
                dense
                text
                class="mb-0"
              >
                This user will sign in using Deakin SSO.
              </v-alert>
              <v-alert
                v-else-if="emailAddress"
                type="info"
                dense
                text
                class="mb-0"
              >
                This user will receive an email to set up their
                password.
              </v-alert>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn color="grey darken-1" text @click="onCancel">
          Cancel
        </v-btn>
        <v-btn
          color="primary"
          :disabled="!isValid"
          :loading="loading"
          @click="onInvite"
        >
          Send Invite
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { EMAIL_REGEX } from '@/modules';
import { isDeakinEmail } from '@/auth/passwordReset';

export default {
  name: 'UserInviteDialog',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['input', 'invite', 'cancel'],
  data: () => ({
    emailAddress: '',
    name: '',
    emailRules: [
      (v) => !!v || 'Email is required',
      (v) => EMAIL_REGEX.test(v) || 'Email must be valid',
    ],
  }),
  computed: {
    isDeakinEmail() {
      return isDeakinEmail(this.emailAddress);
    },
    isValid() {
      return this.emailAddress && EMAIL_REGEX.test(this.emailAddress);
    },
  },
  watch: {
    value(newValue) {
      if (!newValue) {
        this.resetForm();
      }
    },
  },
  methods: {
    onInvite() {
      if (this.isValid) {
        this.$emit('invite', {
          emailAddress: this.emailAddress,
          name: this.name || null,
        });
      }
    },
    onCancel() {
      this.$emit('cancel');
      this.$emit('input', false);
    },
    resetForm() {
      this.emailAddress = '';
      this.name = '';
    },
  },
};
</script>
